import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';

const styles = {
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  menuButton: {
    marginLeft: -6,
    marginRight: 0,
  },
  heading: {
    padding: '5px 16px 0px 15px',
    marginBottom: '-10px',
  }
};

class DrawerMenu extends React.Component {
  constructor(props){
    super(props);
    }
  state = {
    top: false,
    left: false,
    bottom: false,
    right: false,
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };


  render() {
    const { classes } = this.props;

    const sideList = (
      <div className={classes.list}>
        <List>
            <ListItem>
               <Link to="/" style={{textDecoration: 'none', color:"white"}}>Home</Link>
            </ListItem>
            <ListItem>
               <Link to="/TrueNorthServer" style={{textDecoration: 'none', color:"white"}}>TrueNorth Server</Link>
            </ListItem>
            <ListItem>
               <Link to="/TrueNorthGarmin" style={{textDecoration: 'none', color:"white"}}>TrueNorth Garmin App</Link>
            </ListItem>
            <ListItem>
                <Link to="/Download" style={{textDecoration: 'none', color:"white"}}>Downloads</Link>
            </ListItem>
            <ListItem>
                <Link to="/Contacts" style={{textDecoration: 'none', color:"white"}}>Contacts</Link>
            </ListItem>
        </List>
      </div>
    );

    return (
      <div>
        <IconButton onClick={this.toggleDrawer('left', true)} className={classes.menuButton} color="inherit" aria-label="Menu">
              <MenuIcon />
        </IconButton>

        <Drawer open={this.state.left} onClose={this.toggleDrawer('left', false)}>
          <div
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer('left', false)}
            onKeyDown={this.toggleDrawer('left', false)}
            style={{backgroundColor:'#323232', height:'100%'}}
            >
            {sideList}
          </div>
        </Drawer>
      </div>
    );
  }
}

DrawerMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DrawerMenu);